"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = distance;
function distance(pointA, pointB) {
  var xA = pointA.x,
      yA = pointA.y;
  var xB = pointB.x,
      yB = pointB.y;

  var xs = Math.pow(xB - xA, 2);
  var ys = Math.pow(yB - yA, 2);
  return Math.sqrt(xs + ys);
}



//////////////////
// WEBPACK FOOTER
// ./~/triangles-canvas/~/@danmmx/distance-between-points/dist/index.js
// module id = 439
// module chunks = 35783957827783